// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @components
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { InputSafe } = require('commonsComponents/inputSafe');
const TransactionRepetition = require('components/transactionRepetition/transactionRepetition');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;

const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_LOCALE,
    DATE_PICKER_CUSTOM_DATE_FORMAT
} = require('constants/commonsComponents');

class CardChargePeriodicTransfer extends React.Component {
    constructor(props) {
        super(props);

        this.handleCardChargePeriodicityEnabled = this.handleCardChargePeriodicityEnabled.bind(this);
        this.handleCardChargePeriodicityType = this.handleCardChargePeriodicityType.bind(this);
        this.handleCardChargePeriodicityRange = this.handleCardChargePeriodicityRange.bind(this);
        this.handleCardChargePeriodicityDate = this.handleCardChargePeriodicityDate.bind(this);
        this.handleCardChargePeriodicityCount = this.handleCardChargePeriodicityCount.bind(this);
        this.setCardChargeDate = this.setCardChargeDate.bind(this);
        this.handlePeriodicityConcept = this.handlePeriodicityConcept.bind(this);
    }

    handleCardChargePeriodicityEnabled(event) {
        if(!event.target.checked) {
            const today = moment().startOf('day');
            this.props.setTodayDate(today);
        }
        this.props.handlePeriodicityEnabled(event.target.checked);
    }

    handleCardChargePeriodicityType(type) {
        this.props.handlePeriodicityType(type);
    }

    handleCardChargePeriodicityRange(range) {
        this.props.handlePeriodicityRange(range);
    }

    handleCardChargePeriodicityDate(date) {
        this.props.handlePeriodicityDate(date);
    }

    handleCardChargePeriodicityCount(count, date) {
        this.props.handlePeriodicityCount(count, date);
    }

    handlePeriodicityConcept(event) {
      this.props.handlePeriodicityConcept(event.target.value)
    }

    setCardChargeDate(date) {
        this.props.setDate(date);
    }

    render() {
        const { immCardCharge } = this.props;
        const immCardChargeStep1 = immCardCharge.getIn(['steps', 0]);
        let transactionRepetition;
        let selectedDate = immCardChargeStep1.get('date');
        let dateErrorMessage;
        const isEditFlow = immCardChargeStep1.get('isEdit');
        const currentDate = moment().startOf('day');
        const periodicityEnabled = immCardChargeStep1.get('periodicityEnabled');
        const periodicityConcept = immCardChargeStep1.get('periodicityConcept');
        const periodicityConceptDirty = immCardChargeStep1.get('periodicityConceptDirty');
        let periodicityCardMessage;

        if(selectedDate <= currentDate){
            dateErrorMessage = formatText('cardCharge-dateErrorMessage');
        }

        if (periodicityEnabled) {
            periodicityCardMessage = (
                <div className="card-charge-step-one__periodicity-card-message-container">
                    <p className="card-charge-step-one__periodicity-card-message">
                        <FormattedText value="cardChargePeriodicity-cardChargePeriodicity_periodicityCardMessage" />
                    </p>
                </div>
            );

            transactionRepetition = (
                <div>
                    <div className="card-charge-step-one__group__concept">
                        <InputSafe
                            type="text"
                            autoComplete="off"
                            maxLength={40}
                            label={formatText('cardCharge-concept')}
                            value={periodicityConcept}
                            onChange={this.handlePeriodicityConcept}
                            onBlur={this.handlePeriodicityConcept}
                            errorState={periodicityConceptDirty}
                            errorMessage={formatText('cardCharge-conceptError')}
                    />
                    </div>
                    <TransactionRepetition
                        isEcardOrOYFlow={true}
                        onCountChange={this.handleCardChargePeriodicityCount}
                        onDateChange={this.handleCardChargePeriodicityDate}
                        onRangeChange={this.handleCardChargePeriodicityRange}
                        onTypeChange={this.handleCardChargePeriodicityType}
                        periodicityCount={immCardChargeStep1.get('periodicityCount')}
                        periodicityCountIsInvalid={!immCardChargeStep1.get('periodicityCountIsValid')}
                        periodicityDate={immCardChargeStep1.get('periodicityDate')}
                        periodicityMinDate={immCardChargeStep1.get('periodicityMinDate')}
                        periodicityRange={immCardChargeStep1.get('periodicityRange')}
                        periodicityType={immCardChargeStep1.get('periodicityType')}
                        transferDate={immCardChargeStep1.get('date')}
                />
                </div>
            );
        } else {
            selectedDate = moment().startOf('day');
        }

        return (
            <div className="card-charge-step-one__group">
                <div className="transfer-first-step__date">
                    <DatePickerCustom
                        callback={this.setCardChargeDate}
                        dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        disabled={!periodicityEnabled}
                        label={formatText('cardChargePeriodicity-step1DateOfIssue')}
                        locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                        minDate={immCardChargeStep1.get('minDate')}
                        placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                        selectedDate={selectedDate}
                    />
                </div>
                <OKCheckbox
                    idName="repeatInput"
                    label={formatText('transferSummary-step1Repeat')}
                    value={periodicityEnabled}
                    onChange={this.handleCardChargePeriodicityEnabled}
                    disabled={isEditFlow}
                    extraClass="transfer-first-step__checkbox-periodicity"
                />
                {periodicityCardMessage}
                <div className="transfer-first-step__date-error-message">
                    {dateErrorMessage}
                </div>
                {transactionRepetition}
            </div>
        );
    }
}

CardChargePeriodicTransfer.propTypes = {
    handlePeriodicityCount: PropTypes.func,
    handlePeriodicityDate: PropTypes.func,
    handlePeriodicityEnabled: PropTypes.func,
    handlePeriodicityRange: PropTypes.func,
    handlePeriodicityType: PropTypes.func,
    handlePeriodicityConcept: PropTypes.func,
    immCardCharge: PropTypes.object.isRequired,
    setDate: PropTypes.func,
    setTodayDate: PropTypes.func
};

module.exports = CardChargePeriodicTransfer;
